export const APIS = {
  Login: "/website/auth/login",
  Registration: "/website/auth/registration",
  SignUp: {
    // Individual: "/users/individual/create/",
  },
  ChangePassword: "/website/auth/change-password",
  Common: {
    AppSetup: "/common/master/app-setup",
    //
    Rules: "/common/master/rules",
    TAndC: "/common/master/t-and-c",
    Privacy: "/common/master/privacy",
    SocialMedia: "/common/master/social-media",
    ContactUs: "/common/master/contact-us",
    AllState: "/common/master/all-state",
    AllBanner: "/common/master/all-banner",
    AllBigwin: "/common/master/all-bigwin",
    AllAgent: "/common/master/all-agent",
    AllLeaderboard: "/common/master/all-leaderboard",
    //
    AllGames: "/common/games/all-games",
    AllCompetitionsMatchs: "/common/games/all-competitions-matchs?",
    MatchDetails: "/common/games/match-details",
    MatchOdds: "/common/games/match-odds",
    AllLiveMarketsData: "/common/games/all-live-markets-data",
    OnlyLiveGamesMatches: "/common/games/only-live-games-matches?",
    MarketAnalysisLiveGamesMatches:
      "/common/games/market-analysis-games-matches?",
  },

  Profile: {
    Settlement: {
      Settlement: "/website/profile/settlement",
    },
    Statement: {
      CRUD: "/website/profile/statement",
      Exports: "/website/profile/statement-exports",
    },
    Activity: {
      CRUD: "/website/profile/activity",
    },
  },
  Bets: {
    Place: "/website/bets/place",
    Cancelled: "/website/bets/cancelled",
    Calculations: "/website/bets/calculations",
    LiveBets: "/website/bets/live-bets",
    UnmatchBets: "/website/bets/unmatch-bets",
    LiveBetsAmount: "/website/bets/live-bets-amount",
    CompletedBets: "/website/bets/completed-bets",
    BetButtons: "/website/bets/bet-buttons",
    BookShowBets: "/website/bets/bookshow-bets",
    Jackpot: "/website/bets/jackpot",
  },

  Wallet: {
    Fund: "/website/profile/fund-request",
    Withdraw: "/website/profile/withdraw-request",
  },
};
